module.exports = __webpack_public_path__ + "static/media/three.9562cb93.svg";